export default "__VITE_ASSET__CcuwxPIk__"